import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-default-layout',
  templateUrl: './student-default-layout.component.html',
  styleUrls: ['./student-default-layout.component.scss']
})
export class StudentDefaultLayoutComponent implements OnInit {
  currentPage = "";
  constructor() { }

  ngOnInit(): void {
  }

}
